var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mapa",staticClass:"google-map mb-3 mt-0"},[_c('i',{staticClass:"fas fa-car"})])}
var staticRenderFns = []

export { render, staticRenderFns }